<template>
  <!-- <div>
      <div class="cart-modal">
        <div class="text-center">
          <h3 class="modal-title">Your Cart</h3>
          <p class="product-numbers" v-if="products.length > 0">{{ products.length }} Products</p>
        </div>
        <div class="cart-items" v-if="products.length > 0">
          <div
            class="item d-flex align-items-center justify-content-between"
            v-for="(product, index) in products"
            :key="product.id"
          >
            <div class="item-info d-flex align-items-center">
              <div
                class="items-image bg-cover"
                :style="{'background-image': `url('${product.images[0]}')`}"
              ></div>
              <div class="text">
                <p class="item-name">{{ product.name }}</p>
                <p class="item-price">{{ product.price | currency}}</p>
              </div>
            </div>

            <div class="item-info m-auto">
              <div class="text">
                <p class="item-name invisible">{{ product.name }}</p>
                <p class="item-price">{{ product.price * product.quantity | currency}}</p>
              </div>
            </div>
            <div class="quantity rounded d-inline-block d-md-flex justify-content-between ml-auto">
              <div>
                <i
                  class="fas fa-angle-left decrease-quantity"
                  @click="decreaseQuantity(product.id)"
                ></i>
                <input
                  type="number"
                  name="quantity"
                  :value="product.quantity"
                  class="quantity-input"
                  min="1"
                />
                <i
                  class="fas fa-angle-right increase-quantity"
                  @click="increaseQuantity(product.id)"
                ></i>
              </div>
            </div>
            <span class="remove-item" @click="deleteCartItem(index)">
              <i class="fas fa-times"></i>
            </span>
          </div>
        </div>
        <div v-else class="text-center my-3">
          <h6>Your Cart is empty</h6>
        </div>
      </div>
  </div>-->

  <div>
    <!-- cart section -->
    <section class="cart-page">
      <div class="container">
        <div class="cart">
          <div class="d-flex justify-content-between col-md-7 col-lg-8 p-0">
            <h1 class="heading-title">Your Cart</h1>
            <span class="product-numbers" v-if="products.length > 0"
              >{{ products.length }} Products</span
            >
          </div>
          <div class="row justify-content-between">
            <div class="col-md-7 col-lg-8">
              <!-- cart-items -->
              <div class="cart-items">
                <!-- heading part -->
                <div class="row heading d-none d-lg-flex mb-3">
                  <div class="col-lg-6">
                    <h5>PRODUCT</h5>
                  </div>
                  <div class="col-lg-2">
                    <h5>PRICE</h5>
                  </div>
                  <div class="col-lg-2">
                    <h5>QUANTITY</h5>
                  </div>
                  <div class="col-lg-2">
                    <h5>TOTAL</h5>
                  </div>
                </div>
                <!-- end heading part -->

                <div class="items-container" v-if="products.length > 0">
                  <!-- cart-item -->
                  <div
                    class="cart-item row align-items-center justify-content-between"
                    v-for="(product, index) in products"
                    :key="product.id"
                  >
                    <div class="col-12 col-lg-6 d-flex align-items-center mb-2">
                      <span
                        class="remove-item d-none d-lg-block mr-2"
                        @click="deleteCartItem(index)"
                      >
                        <i class="fas fa-times"></i>
                      </span>
                      <div
                        class="item-info d-flex justify-content-between align-items-center"
                      >
                        <div
                          class="item-image bg-cover ml-0"
                          :style="{
                            'background-image': `url('${product.images[0]}')`
                          }"
                        ></div>
                        <div class="more-info">
                          <p class="product-name">{{ product.name }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="col d-lg-none">
                      <div>
                        <span
                          class="remove-item"
                          @click="deleteCartItem(index)"
                        >
                          <i class="fas fa-times"></i>
                        </span>
                      </div>
                    </div>
                    <div class="col col-lg-2">
                      <p class="price">{{ product.price | currency }}</p>
                    </div>
                    <div class="col col-lg-2">
                      <div class="quantity rounded d-inline-block w-auto">
                        <div>
                          <i
                            class="fas fa-angle-left decrease-quantity"
                            @click="decreaseQuantity(product.id)"
                          ></i>
                          <input
                            type="number"
                            name="quantity"
                            :value="product.quantity"
                            class="quantity-input"
                            min="1"
                          />
                          <i
                            class="fas fa-angle-right increase-quantity"
                            @click="increaseQuantity(product.id)"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div class="col col-lg-2">
                      <p class="total">
                        {{ (product.price * product.quantity) | currency }}
                      </p>
                    </div>
                  </div>

                  <div class="cart-details bg-transparent m-0 p-0 mt-3">
                    <p class="total d-flex justify-content-between">
                      CART TOTAL
                      <span class="total-value">{{
                        totalPrice | currency
                      }}</span>
                    </p>
                  </div>
                  <!-- end cart-item -->
                </div>
                <div v-else class="text-center my-3">
                  <h5>Your Cart is empty</h5>
                </div>
              </div>
              <!-- cart-items -->
            </div>
            <div class="col-md-5 col-lg-4">
              <div class="cart-details">
                <h4 class="title">Cart Total</h4>
                <!-- <p class="subtotal d-flex justify-content-between">
                  Subtotal
                  <span>KD17</span>
                </p>
                <p class="discount d-flex justify-content-between">
                  Discount
                  <span>-4</span>
                </p>
                <p class="shipping d-flex justify-content-between">
                  Shipping
                  <span>KD5</span>
                </p>-->
                <p class="total d-flex justify-content-between">
                  CART TOTAL
                  <span class="total-value">{{ totalPrice | currency }}</span>
                </p>
                <button
                  class="btn main-btn m-auto d-block w-100"
                  @click="checkout"
                >
                  Proceed to Checkout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--end cart section -->
  </div>
</template>

<script>
import "../../sass/cart.scss";
import axios from "axios";
var stripe = require("stripe-client")(
  "pk_test_h3PRdZS6t4iq27Z1xntX3F2R00RCHC6BRW"
);

export default {
  name: "checkout",
  data() {
    return {
      sessionId: ""
    };
  },
  computed: {
    products() {
      return this.$store.getters["cartModule/getCartItems"];
    },
    totalPrice() {
      return this.$store.getters["cartModule/getTotalPrice"];
    }
  },
  methods: {
    deleteCartItem(productId) {
      this.$store.commit("cartModule/deleteCartItem", productId);
    },
    decreaseQuantity(productId) {
      this.$store.commit("cartModule/decreaseQuantity", productId);
    },
    increaseQuantity(productId) {
      this.$store.commit("cartModule/increaseQuantity", productId);
    },
    checkout() {
      stripe;
      // .redirectToCheckout({
      //   // Make the id field from the Checkout Session creation API response
      //   // available to this file, so you can provide it as parameter here
      //   // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
      //   sessionId: this.sessionId
      // })
      // .then(function() {
      //   // If `redirectToCheckout` fails due to a browser or network
      //   // error, display the localized error message to your customer
      //   // using `result.error.message`.
      // });
      // let products = this.products.map(item => ({[item.id]: item.quantity}));
      let products = this.products.map(item => {
        return { [item.id]: item.quantity };
      });
      products = Object.assign({}, ...products);
      // console.log(products);
      axios
        .get("http://localhost:5000/market-b447f/us-central1/CheckoutFunc", {
          params: {
            products: products
          }
        })
        .then(() => {
          // this.sessionId = res.data.id;
          // console.log(res);
        })
        .catch(() => {
          // console.log(err);
        });
    },
    created() {}
  }
};
</script>
